import React, { useContext } from 'react';
import { ListingCard } from 'shared-components/ViewFragments/SearchPage/ListingCard';
import { DataImages } from 'shared-components/Components/Property/PropertyCard/CardImageGallery/web';
import { UltimosIngresosItem } from './graphql';
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context';
import './style.css';

interface UltimosIngresosPropertyCardProps {
	data: UltimosIngresosItem;
	preloadImg?: boolean;
}

export const UltimosIngresosPropertyCard: React.FC<UltimosIngresosPropertyCardProps> = ({ data, preloadImg = false }) => {
	const { country_name, country_code } = useContext(ConfigStateContext);
	const locationParts = data.location.split(',').map((part) => part.trim()).filter(Boolean);
	const neighbourhood = locationParts[0] || data.location;
	const city = locationParts.length > 1 ? locationParts[1] : null;
	const state = locationParts.length > 2 ? locationParts.slice(2).join(', ') : null;

	const images: DataImages[] = data.image ? [{
		id: 1,
		image: data.image.replace(/th.(outside)?\d+x\d+./, ''), //le saco el resize para que lo haga la galería
		tag: null
	}] : [];

	const propertyData = {
		id: data.id,
		legacy_propID: data.id,
		title: data.title,
		link: data.link,
		img: data.image,
		width: 300,
		height: 225,
		description: data.content,
		subtitle: data.content,
		
		price: {
			amount: Math.max(parseInt(data.price) || 5, 5),
			currency: { name: '$' } as any
		},
		currency: { name: '$' } as any,
		hidePrice: false,
		
		operation_type: data.content.includes('alquiler') ? 'rent' : 'sale',
		operation_type_id: data.content.includes('alquiler') ? 2 : 1,
		
		images: images,
		image_count: images.length,
		
		address: data.location,
		neighborhood: {
			name: neighbourhood
		},
		locations: [{
			name: data.location,
			country: country_name,
			neighbourhood: neighbourhood ? [{ name: neighbourhood }] : [],
			city: city ? [{ name: city }] : [],
			state: state ? [{ name: state }] : []
		}],
		
		property_type: {
			name: data.category
		},
		property_type_id: Number(data.category),

		// Datos de GraphQL
		bedrooms: data.bedrooms || 0,
		bathrooms: data.bathrooms || 0,
		m2: data.area,

		singleImage: true,
		isExternal: false,
	};

	return (
		<ListingCard 
			shortCard={true} 
			data={propertyData} 
			preloadImg={preloadImg} 
			hideCta 
			staticGallery 
			showExpenses={false}
		/>
	);
};
